
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apply/platform-partner",
      function () {
        return require("private-next-pages/apply/platform-partner.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apply/platform-partner"])
      });
    }
  